import { ref } from 'vue';
import axios from 'axios';
import apiClient from '../libs/axios';
import { apiUrl } from '../constans';

const appUrl = process.env.NODE_ENV === 'production'
    ? 'https://app.crmred.co'
    : 'http://localhost:5173';

export function useImpersonate() {
    const isImpersonating = ref(localStorage.getItem('is_impersonating') === 'true');

    const impersonateUser = async (userId, userName) => {
        if (!confirm(`¿Iniciar sesión como ${userName}?`)) return;

        try {
            const response = await apiClient.post(`/v2/super-admin/impersonate/${userId}`);

            if (response.data.success) {
                const { access_token, impersonation_session_id } = response.data.data;

                // Guardar token admin original
                localStorage.setItem('admin_access_token', localStorage.getItem('access_token'));
                localStorage.setItem('impersonation_session_id', String(impersonation_session_id));
                localStorage.setItem('is_impersonating', 'true');

                isImpersonating.value = true;

                // Abrir crmred en nueva pestaña con la ruta de impersonación
                const url = `${appUrl}/auth/impersonation?token=${encodeURIComponent(access_token)}`;
                window.open(url, '_blank');
            }
        } catch (error) {
            console.error('Error al impersonar usuario:', error);
            alert(error?.response?.data?.message || 'Error al iniciar impersonación');
        }
    };

    const stopImpersonating = async () => {
        const adminToken = localStorage.getItem('admin_access_token');
        const sessionId = localStorage.getItem('impersonation_session_id');

        if (!adminToken || !sessionId) return;

        try {
            // Usar axios directo con el token admin, NO apiClient
            // porque el interceptor usaría el token del usuario impersonado
            await axios.post(
                `${apiUrl}/v2/super-admin/stop-impersonation`,
                { session_id: Number(sessionId) },
                {
                    headers: {
                        'Authorization': `Bearer ${adminToken}`,
                        'Content-Type': 'application/json',
                    },
                }
            );
        } catch (error) {
            console.error('Error al detener impersonación:', error);
        } finally {
            localStorage.removeItem('is_impersonating');
            localStorage.removeItem('impersonation_session_id');
            const adminAccessToken = localStorage.getItem('admin_access_token');
            localStorage.removeItem('admin_access_token');

            // Restaurar token del admin
            localStorage.setItem('access_token', adminAccessToken);

            window.location.href = '/';
        }
    };

    return { isImpersonating, impersonateUser, stopImpersonating };
}
